const testNavigator = (userAgent: string) => (test: string) =>
  userAgent.includes(test);

export function detectUserAgent(): string {
  const { userAgent } = window.navigator;
  const testUserAgent = testNavigator(userAgent);

  if (testUserAgent('Firefox')) return 'Mozilla Firefox';
  if (testUserAgent('Opera') || testUserAgent('OPR')) return 'Opera';
  if (testUserAgent('Trident')) return 'Internet Explorer';
  if (testUserAgent('Edge')) return 'Microsoft Edge';
  if (testUserAgent('Chrome')) return 'Chrome/Chromium';
  if (testUserAgent('Safari')) return 'Apple Safari';
  return 'unknown';
}
